import React from "react";
import { View, StyleSheet } from "react-native";

import colors from "@constants/color";
import Text from "@components/CustomText";

const DelayTag = ({ delay }) => {
  return (
    <View style={styles.delayedTag}>
      <Text newfont variant="caption_1" style={{ color: colors.white }}>
        {delay}
      </Text>
    </View>
  );
};

const styles = StyleSheet.create({
  delayedTag: {
    backgroundColor: colors.plain_red,
    borderRadius: 18,
    alignItems: "center",
    paddingHorizontal: 8,
  },
});

export default DelayTag;
